import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RolesAndRightsService {
  private httpClient = inject(HttpClient);

  public assignUserRoles(
    userID,
    userMail,
    roles,
    partnerName?
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append('userId', userID);
    params = params.append('userMail', userMail);
    if (partnerName != null) {
      params = params.append('partner', partnerName);
    }
    return this.httpClient.post(
      'api/addUserRoles',
      { roles },
      {
        params,
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  public getAllXeresRoles(partner?): Observable<any> {
    let params = new HttpParams();
    if (partner != null) {
      params = params.append('partner', partner);
    }
    return this.httpClient.get('api/getPartnerRoles', {
      params,
      responseType: 'json',
    });
  }

  public checkRole(role): Observable<any> {
    return this.httpClient.post(
      'api/hasRole',
      { role },
      {
        observe: 'response',
        responseType: 'json',
      }
    );
  }

  public checkFavouriteTheme(): Observable<any> {
    return this.httpClient.get('api/getQuicksightThemeArn', {
      responseType: 'json',
    });
  }

  public invalidateUserSession(partner): Observable<any> {
    let params = new HttpParams();
    params = params.append('partner', partner);
    return this.httpClient.post('api/InvalidateUserSession', {
      params,
      observe: 'response',
      responseType: 'json',
    });
  }

  public checkRight(right): Observable<any> {
    return this.httpClient.post(
      'api/hasRight',
      { right },
      {
        observe: 'response',
        responseType: 'json',
      }
    );
  }

  public searchUser(userID, partner?): Observable<any> {
    let params = new HttpParams();
    params = params.append('searchString', userID);
    if (partner != null) {
      params = params.append('partner', partner);
    }
    return this.httpClient.get('api/userLookup', {
      params,
      responseType: 'json',
    });
  }
  public getUserApplication(userID, partner?): Observable<any> {
    let params = new HttpParams();
    params = params.append('userId', userID);
    if (partner != null) {
      params = params.append('partner', partner);
    }
    return this.httpClient.get('api/getUserRoles', {
      params,
      responseType: 'json',
    });
  }

  public addNewRole(role, partnerName): Observable<any> {
    let params = new HttpParams();
    params = params.append('role', role.trim());
    params = params.append('partner', partnerName);
    return this.httpClient.put(
      'api/addXerxesRole',
      {},
      {
        params,
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  public updateRole(role, partnerName?): Observable<any> {
    let params = new HttpParams();
    if (partnerName != null) {
      params = params.append('partner', partnerName);
    }
    return this.httpClient.post('api/updateXerxesRole', role, {
      params,
      observe: 'response',
      responseType: 'text',
    });
  }
  public setDefaultRole(id: any, partner: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('role', id);
    params = params.append('partner', partner);
    return this.httpClient.post(
      'api/setDefaultRole',
      {},
      {
        params,
        observe: 'response',
        responseType: 'text',
      }
    );
  }
  public deleteRole(role, partner) {
    let params = new HttpParams();
    if (partner != null) {
      params = params.append('partner', partner);
    }
    params = params.append('role', role);
    return this.httpClient.delete('api/deleteXerxesRole', {
      params,
      responseType: 'json',
    });
  }

  public getParnterRights(partner?): Observable<any> {
    let params = new HttpParams();
    if (partner != null) {
      params = params.append('partner', partner);
    }
    return this.httpClient.get('api/getPartnerRights', {
      params,
      responseType: 'json',
    });
  }

  public getAllRights(partner): Observable<any> {
    let params = new HttpParams();
    params = params.append('partner', partner);
    return this.httpClient.get('api/getAllRights', {
      params,
      responseType: 'json',
    });
  }

  public addNewRight(right, description, partner): Observable<any> {
    let params = new HttpParams();
    params = params.append('right', right.trim());
    params = params.append('description', description || '');
    params = params.append('partnerName', partner);
    return this.httpClient.put(
      'api/addXerxesRight',
      {},
      {
        params,
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  public updateRight(right, partner): Observable<any> {
    let params = new HttpParams();
    params = params.append('partnerName', partner);
    return this.httpClient.post('api/updateXerxesRight', right, {
      params,
      observe: 'response',
      responseType: 'text',
    });
  }

  public deleteRight(right, partner) {
    let params = new HttpParams();
    params = params.append('partnerName', partner);
    params = params.append('right', right);
    return this.httpClient.delete('api/deleteXerxesRight', {
      params,
    });
  }

  exportReports(partnerName): Observable<any> {
    return this.httpClient.get('api/getUserList?partner=' + partnerName, {
      responseType: 'blob',
    });
  }
  exportReportAsExcel(partnerName): Observable<any> {
    return this.httpClient.get('api/getUARList?partner=' + partnerName, {
      responseType: 'blob',
    });
  }
  public getGlobalAccessUserData(id?): Observable<any> {
    return this.httpClient.get('api/globalAccessUserData?id=' + id, {
      responseType: 'json',
    });
  }
  public manageGlobalAccess(decision: any, obj: any): Observable<any> {
    return this.httpClient.post(
      'api/manageGlobalAccess?approved=' + decision,
      obj,
      {
        responseType: 'json',
      }
    );
  }

  public getUserWithGlobalAccess(email?): Observable<any> {
    return this.httpClient.get('api/getUserWithGlobalAccess', {
      responseType: 'json',
    });
  }

  public removeGlobalAccess(
    emails: String[],
    partnerName: String
  ): Observable<any> {
    const url = `api/removeUsersWithGlobalAccess?partnerName=${partnerName}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpClient.post(url, emails, { headers, responseType: 'text' });
  }

  public getUserRoleForPartner(partner?): Observable<any> {
    let params = new HttpParams();
      params = params.append('partner', partner);
    
    return this.httpClient.get('api/listUsersByPartner', {
      params,
      responseType: 'json',
    });
  }

  getUserDetails(sub: string, organization: string) {
  return this.httpClient.get(`api/getUserDetails`, { 
    params: {
      sub: sub,
      organization: organization
    },
    responseType: 'text' as 'json' 
  });
}

}
